function initTypingHint({
                            inputSelector,
                            placeholderSelector,
                            texts
                        }) {

    const input = document.querySelector(inputSelector);
    const placeholder = document.querySelector(placeholderSelector);

    if (!input || !placeholder || !texts.length) {
        return;
    }

    let textIndex = 0;
    let charIndex = 0;
    let deleting = false;

    function tick() {

        if (input.value.length) {
            setTimeout(tick, 500);
            return;
        }

        const currentText = texts[textIndex];

        if (!deleting) {

            placeholder.textContent =
                currentText.substring(0, charIndex + 1);

            charIndex++;

            if (charIndex === currentText.length) {

                deleting = true;

                setTimeout(tick, 1500);

                return;
            }

        } else {

            placeholder.textContent =
                currentText.substring(0, charIndex - 1);

            charIndex--;

            if (charIndex === 0) {

                deleting = false;

                textIndex = (textIndex + 1) % texts.length;
            }
        }

        setTimeout(
            tick,
            deleting ? 40 : 80
        );
    }

    input.addEventListener('input', () => {

        placeholder.style.display =
            input.value.length ? 'none' : 'block';
    });

    tick();
}

document.addEventListener('DOMContentLoaded', () => {

    initTypingHint({
        inputSelector: '#mast-q',
        placeholderSelector: '.mast__search-placeholder',
        texts: [
            'Regulator czarny',
            'Listwa 5 stref',
            'Sterownik rolet',
            'Ogrzewanie podłogowe',
            'Regulator kotła'
        ]
    });

});
